import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppConstants } from 'src/app/constants/app.constants';
import { ReportsService } from 'src/app/services/reports.service';
import { CommonPdfComponent } from '../../common-pdf/common-pdf.component';
import { saveAs } from 'file-saver';
import { interval, Observable } from 'rxjs';
import { download, Download } from '../../model/download';
import { Saver, SAVER } from '../../model/saver';
import { HttpErrorResponse } from '@angular/common/http';
import { ApproveDialogComponent } from '../../approve-dialog/approve-dialog.component';
@Component({
    selector: 'app-un-signed-packages',
    templateUrl: './un-signed-packages.component.html',
    styleUrls: ['./un-signed-packages.component.scss'],
    standalone: false
})
export class UnSignedPackagesComponent extends CommonPdfComponent {
  download$: Observable<Download>
  isFileDownload=false;
  constructor(private reportsService: ReportsService, protected dialog: MatDialog, @Inject(SAVER) private save: Saver) {
    super(dialog);
  }

  ngOnInit(): void {
    
    this.reportsService.getUnSignedPackagesReport().subscribe(data=>{
      this.isFileDownload=true;
      console.log(data.headers.get('Content-Disposition'));
      let contentDispositionHeader= data.headers.get('Content-Disposition')
       var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
       result.replace(/"/g, '');
       console.log(result);
      saveAs(new Blob([data.body], { type: AppConstants.MIME_TYPES['xlsx'] }), "UnsignedPackages_.xlsx");
      //this.openReport(data, dialogdata)
    },(error:HttpErrorResponse)=>{
     
      if(error && error.status===404){
      let dialogData= {
        title: 'No Records Found',
        message: "No records to display.",
       
      }
      this.dialog.open(ApproveDialogComponent,{
        data:dialogData,panelClass: 'my-class'
      });
    }
  })

  }

  progressbarValue = 100;
  curSec: number = 0;

  startTimer(seconds: number) {
    const time = seconds;
    const timer$ = interval(1000);

    const sub = timer$.subscribe((sec) => {
      this.progressbarValue = 100 - sec * 100 / seconds;
      this.curSec = sec;

      if (this.curSec === seconds) {
        sub.unsubscribe();
      }
    });
  }

}
